import React, { useCallback, useEffect, useMemo, useRef, useState } from "react"
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ErrorIcon from '@mui/icons-material/Error';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import {
  DataGridPro,
  DataGridProProps,
  GridColDef,
  GridSelectionModel,
  GridToolbar,
  GridFilterModel,
  getGridStringOperators,
  useGridApiRef,
} from "@mui/x-data-grid-pro"
import { RiExpandUpDownLine } from "react-icons/ri"
import EditIcon from '@mui/icons-material/Edit';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Typography,
  Select,
  FormControl,
  useTheme,
  useMediaQuery,
  Tooltip,
} from "@mui/material"
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import useAuth from "../../context/AuthProvider"
import moment from "moment"
import { OTRFlags, OTRModelDTO, OTRModuleModel } from "../../models/OTRModuleModel"
import { SelectControl } from "../Elements/select"
import { MenuDropdown } from "../Elements/MenuDropdown"
import Swal from "sweetalert2"
import { OffsetNotes } from "../Elements/OffsetNotes"
import { toCurrency } from "../../helper/utils"
import { config } from "../../Constants"
import { AddEditOTR } from "../AddEdit/AddEditOTR"
import formatPrice from "../../helper/currencyFormatter"
import { color } from "@mui/system";
import { apiClient } from "../../helper/api";
import { compactString, formatUtcToLocal } from "../../helper/utils";
import { transactionTypeList } from "../../Pages/OpenTaxReport/constants";
import { KeyboardArrowUp } from "@mui/icons-material";
import { KeyboardArrowDown } from "@mui/icons-material";

interface Iprops {
  listData: OTRModuleModel[]
  pageSize: number
  currentPage: number
  totalCount: number
  onPageChange: (val: number) => void
  onPageSizeChange: (val: number) => void
  getOptions: (field: string) => string[]
  fetchOptions: (field: string, rowVal?: any) => Promise<string[]>
  checkIsValid: (field: string, rowVal?: any) => boolean
  onImportXlsx: (val: File, xlsItem: string) => void
  onExportXlsx: (val: OTRModuleModel[]) => void
  onRemoveItems: (val: OTRModuleModel[]) => void
  onOffsetItems: (val: OTRModuleModel[]) => void
  onApproveItems: (val: OTRModuleModel[]) => void
  onItemChange: (val: OTRModuleModel) => void
  selectedRows: OTRModuleModel[];
  setSelectedRows: (val: OTRModuleModel[]) => void;
  selectionModel: GridSelectionModel;
  setSelectionModel: (val: GridSelectionModel) => void;
  fetchData: () => void
  status: boolean
  setStatus: (field: boolean) => void
  isImportCompleted: string
  onSortChange?: (field: string, direction: string) => void
  filterModel?: { items: { columnField: string, value: string, operatorValue: string }[], logicOperator?: 'and' | 'or' }
  setFilterModel?: (filterModel: { items: { columnField: string, value: string, operatorValue: string }[], logicOperator?: 'and' | 'or' }) => void
  onFilterChange?: (filterModel: { items: { columnField: string, value: string, operatorValue: string }[], logicOperator?: 'and' | 'or' }) => void
  sortModel: any
  setSortModel: React.Dispatch<React.SetStateAction<any>>
}

export const OTRModuleList: React.FC<Iprops> = ({
  listData,
  pageSize,
  currentPage,
  totalCount,
  onPageChange,
  onPageSizeChange,
  getOptions,
  fetchOptions,
  checkIsValid,
  onImportXlsx,
  onExportXlsx,
  onRemoveItems,
  onOffsetItems,
  onApproveItems,
  onItemChange,
  selectedRows,
  setSelectedRows,
  selectionModel,
  setSelectionModel,
  fetchData,
  status,
  setStatus,
  isImportCompleted,
  onSortChange,
  filterModel,
  setFilterModel,
  onFilterChange,
  sortModel,
  setSortModel,
}) => {
  const { user } = useAuth()
  const token = user?.token
  const theme = useTheme()
  const isTabletOrDown = useMediaQuery(theme.breakpoints.down('md'))
  const isLargeOrDown = useMediaQuery(theme.breakpoints.down('lg'))
  const otrGridApiRef = useGridApiRef()
  const [open, setOpen] = useState(false);
  const handleOpen = () => { setOpen(true); };
  const handleClose = () => { setOpen(false); };
  const [loading, setLoading] = useState(false);
  const [offSetNotes, setOffsetNotes] = useState<string>('');
  const [options, setOptions] = useState<string[]>([])
  const [OpenOTREdit, setOpenOTREdit] = React.useState(false);
  const handleCloseOTREdit = () => { setOpenOTREdit(false); };

  const initialOTRModelDTO: OTRModelDTO = {
    NewOpenTaxReportId: 0,
    isDeleted: false
  };

  const [Formdata, setFormData] = React.useState(initialOTRModelDTO);
  const handleSubmit = () => {
    fetchData();
    setOpenOTREdit(false);
  };

  // Filter operators for string columns
  const filterOperators = getGridStringOperators();


  const onMenuItemClick = async (field: string, rowVal?: any) => {
    setOptions([])
    const optionList = await fetchOptions(field, rowVal) || []
    setOptions(optionList)
  }

  const onRowsSelectionHandler = (ids: GridSelectionModel) => {
    const selectedIDs = new Set(ids)
    const selectedRowData = listData.filter(
      (row) => selectedIDs.has(row?.rowNum ?? "")
    )
    setSelectedRows(selectedRowData)
    setSelectionModel(ids)
    console.log({ selectedRowData, ids })
  }

  const handleDeleteItems = () => {
    if (!selectedRows || selectedRows.length < 1) return
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      showCancelButton: true,
      confirmButtonColor: '#02A4E3',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Delete',
      customClass: {
        confirmButton: 'btn-radius',
        cancelButton: 'btn-radius',
        popup: 'card-radius'
      }
    })
      .then((result) => {
        if (result.isConfirmed) {
          onRemoveItems(selectedRows)
          setSelectedRows([])
          setSelectionModel([])
        }
      })
  }

  const handleOffsetItems = () => {
    if (!selectedRows || selectedRows.length < 1) return
    setOffsetNotes('');
    handleOpen();
  }

  const handleUpdateOffsetNotes = (newNote: string) => {
    if (!selectedRows || selectedRows.length < 1) return
    const updatedRows = selectedRows.map(item => ({
      ...item,
      offSetNotes: newNote,
    }));

    onOffsetItems(updatedRows);
    setSelectedRows([]);
    setSelectionModel([])
  };

  const handleImportXlsx = (
    _e: React.ChangeEvent<HTMLInputElement>,
    xlsItem: string
  ) => {
    if (!_e || !_e.target.files) return
    onImportXlsx(_e.target.files[0], xlsItem)
  }
  const handleExportXlsx = (val: OTRModuleModel[]) => {
    let values = listData
    if (val && val.length > 0) {
      values = val
    }
    if (values.length <= 0) {
      alert('Please upload a xlsx file')
      return
    }
    onExportXlsx(values)
    setSelectedRows([])
    setSelectionModel([])
  }
  const curExcelFormat = useRef<string>('')
  const onImport = (item: string) => {
    curExcelFormat.current = item
    document.getElementById('uploadXlsxOTR')?.click();
  }

  const initialStatedata = { stateId: 0, stateName: "" };
  const [States, setStates] = useState([initialStatedata]);
  const fetchStateData = () => {
    apiClient("/States/getStates", {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
    })
      .then((responseJson) => {
        if (responseJson?.data != null) {
          setStates(responseJson.data);
        }
      })
  };

  const initialTransactionListdata = { transactionId: 0, transactionTypeName: "" };
  const [Transactions, setTransactions] = useState([initialTransactionListdata]);
  const fetchTransactionListData = () => {
    apiClient(`/TransactionType/getAllTransactionType`, {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
    })
      .then((responseJson) => {
        if (responseJson?.data != null) {
          setTransactions(responseJson.data);
        }
      })
  };

  const handleEdit = (IOTRData: OTRModelDTO) => {
    console.log("Row data received:", IOTRData);
    setLoading(true);

    let a: OTRModelDTO = {
      NewOpenTaxReportId: IOTRData.NewOpenTaxReportId ?? (IOTRData as any).newOpenTaxReportId ?? 0,
      invoiceNumber: IOTRData.invoiceNumber ?? '',
      insuredName: IOTRData.insuredName ?? '',
      policyNumber: IOTRData.policyNumber ?? '',
      homeState: IOTRData.homeState ?? (IOTRData as any).stateName ?? '',
      taxType: IOTRData.taxType ?? (IOTRData as any).taxName ?? '',
      taxPayee: IOTRData.taxPayee ?? '',
      transactionType: IOTRData.transactionType ?? (IOTRData as any).transactionTypeName ?? '',
      coverage: IOTRData.coverage ?? '',
      carrier: IOTRData.carrier ?? (IOTRData as any).carrierName ?? '',
      nAIC: IOTRData.nAIC ?? (IOTRData as any).naicNumber ?? '',
      transEffDate: IOTRData.transEffDate ?? new Date,
      invDate: IOTRData.invDate ?? new Date,
      policyEffDate: IOTRData.policyEffDate ?? new Date,
      policyExpDate: IOTRData.policyExpDate ?? new Date,
      grossPremium: IOTRData.grossPremium ?? '',
      nonAdmittedPremium: IOTRData.nonAdmittedPremium ?? '',
      taxableFees: IOTRData.taxableFees ?? '',
      nonTaxableFees: IOTRData.nonTaxableFees ?? '',
      taxAmt: IOTRData.taxAmt ?? '',
      taxBalance: IOTRData.taxBalance ?? '',
      client: IOTRData.client ?? (IOTRData as any).customerName ?? '',
      clientDiv: IOTRData.clientDiv ?? '',
      dateInvoiceAdded: IOTRData.dateInvoiceAdded ?? '',
      clientNotes: IOTRData.clientNotes ?? '',
      filerNotes: IOTRData.filerNotes ?? '',
      status: IOTRData.status ?? '',
      whoFiles: IOTRData.whoFiles ?? '',
      isManualTax: IOTRData.isManualTax ?? false,
      fileNumber: IOTRData.fileNumber ?? '',
      endNumber: IOTRData.endNumber ?? '',
      bookDate: IOTRData.bookDate ?? new Date,
      coFee: IOTRData.coFee ?? '',
      coFeeByTodayTaxFlag: IOTRData.coFeeByTodayTaxFlag ?? '',
      coFeeDiff: IOTRData.coFeeDiff ?? '',
      brokFee: IOTRData.brokFee ?? '',
      brokFeeByTodayTax: IOTRData.brokFeeByTodayTax ?? '',
      brokFeeDiff: IOTRData.brokFeeDiff ?? '',
      inspFee: IOTRData.inspFee ?? '',
      inspFeeByTodayTaxFlag: IOTRData.inspFeeByTodayTaxFlag ?? '',
      inspFeeDiff: IOTRData.inspFeeDiff ?? '',
      isInspFeeToCo: IOTRData.isInspFeeToCo ?? false,
      taxSL: IOTRData.taxSL ?? '',
      stampFee: IOTRData.stampFee ?? '',
      otherFee: IOTRData.otherFee ?? '',
      otherTax: IOTRData.otherTax ?? '',
      otherTaxDescr: IOTRData.otherTaxDescr ?? '',
      otherFeeDescr: IOTRData.otherFeeDescr ?? '',
      acctOtherFee: IOTRData.acctOtherFee ?? '',
      statusAdm: IOTRData.statusAdm ?? '',
      isCoFeeTaxable: IOTRData.isCoFeeTaxable ?? false,
      isBrFeeTaxable: IOTRData.isBrFeeTaxable ?? false,
      isInspFeeTaxable: IOTRData.isInspFeeTaxable ?? false,
      taxExempt: IOTRData.taxExempt ?? '',
      nonTaxBrFee: IOTRData.nonTaxBrFee ?? '',
      underwriter: IOTRData.underwriter ?? '',
      filingBatch: IOTRData.filingBatch ?? '',
      dateFiledWSLA: IOTRData.dateFiledWSLA ?? new Date,
      isOroBatch: IOTRData.isOroBatch ?? false,
      tranCode: IOTRData.tranCode ?? '',
      taxNotes: IOTRData.taxNotes ?? '',
      customerPolicyId: IOTRData.customerPolicyId ?? 0,
      stateId: IOTRData.stateId ?? 0,
      transactionTypeId: IOTRData.transactionTypeId ?? 0,
      isDeleted: IOTRData.isDeleted ?? false,
      partnersId: IOTRData.partnersId ?? 0,
      isApproved: IOTRData.isApproved ?? false,
      offSetNotes: IOTRData.offSetNotes ?? '',
      offSet: IOTRData.offSet ?? false,
      isFlagged: IOTRData.isFlagged ?? false,
      insuredId: IOTRData.insuredId ?? 0,
      lOBId: IOTRData.lOBId ?? 0,
      taxesAndFeesId: IOTRData.taxesAndFeesId ?? 0,
      insuranceCompanyId: IOTRData.insuranceCompanyId ?? 0,
      createdBy: IOTRData.createdBy ?? 0,
      dateCreated: IOTRData.dateCreated ?? new Date
    };

    setFormData(a);
    fetchStateData();
    fetchTransactionListData();
    console.log("FormData", Formdata);
    setOpenOTREdit(true);
  };


  const handleCheckImportStatus = () => {
    apiClient(`/OpenTaxReport/CheckImportStatus`, {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((responseJson) => {
        if (responseJson.data != null) {
          console.log(responseJson.data);

          // setIsImportCompleted(responseJson.data);
          // setOpenImportStatusDialog(true);
          if (responseJson.data === 'Completed') {
            setStatus(false)
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });

  };

  useEffect(() => {
    fetchTransactionListData();
  }, []);


  const EditToolbar = () => {
    const [toolbarMenuAnchor, setToolbarMenuAnchor] = useState<null | HTMLElement>(null)
    const openToolbarMenu = Boolean(toolbarMenuAnchor)

    const handleToolbarMenuClose = () => setToolbarMenuAnchor(null)
    const handleToolbarAction = (action: 'filter' | 'columns' | 'exportCsv' | 'exportPrint') => {
      handleToolbarMenuClose()
      const api = otrGridApiRef.current
      if (!api) return
      if (action === 'filter') api.showFilterPanel()
      else if (action === 'columns') (api as any).showPreferences('columns')
      else if (action === 'exportCsv') api.exportDataAsCsv()
      else if (action === 'exportPrint') api.exportDataAsPrint()
    }

    return (
      <React.Fragment>

        <Box display='flex'>
          <Grid sx={{ zIndex: 100 }} container display="flex " px={2} margin={"10px 0px"} justifyContent={"space-between"} flexWrap={"nowrap"}>
            <Grid item xs={2} md={4} lg={6}>
              {isLargeOrDown ? (
                <>
                  <IconButton
                    aria-label="Table options"
                    aria-controls={openToolbarMenu ? 'table-options-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={openToolbarMenu ? 'true' : undefined}
                    onClick={(e) => setToolbarMenuAnchor(e.currentTarget)}
                    sx={{ color: '#2099d2' }}
                  >
                    <MoreVertOutlinedIcon />
                  </IconButton>
                  <Menu
                    id="table-options-menu"
                    anchorEl={toolbarMenuAnchor}
                    open={openToolbarMenu}
                    onClose={handleToolbarMenuClose}
                    MenuListProps={{ 'aria-labelledby': 'table-options-button' }}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  >
                    <MenuItem onClick={() => handleToolbarAction('filter')}>Filter</MenuItem>
                    <MenuItem onClick={() => handleToolbarAction('columns')}>Columns</MenuItem>
                    <MenuItem onClick={() => handleToolbarAction('exportCsv')}>Download as CSV</MenuItem>
                    <MenuItem onClick={() => handleToolbarAction('exportPrint')}>Print</MenuItem>
                  </Menu>
                </>
              ) : (
                <GridToolbar />
              )}
            </Grid>
            <Grid item xs={10} md={8} lg={6}>
              <Grid container display='flex' gap={2} justifyContent={'flex-end'}>
                <Grid item>
                  <input
                    id='uploadXlsxOTR'
                    className='d-none'
                    type='file'
                    accept={`.xls,.xlsx,.csv`}
                    onChange={file => handleImportXlsx(file, curExcelFormat.current)}
                  />
                  <MenuDropdown
                    menuTitle="Import"
                    items={getOptions('excelFormatList')}
                    onItemClick={onImport}
                    variant="outlined"
                    size="medium"
                    sx={{
                      textTransform: 'none',
                      fontWeight: 600,
                      borderColor: '#e2e8f0',
                      color: '#475569',
                      '&:hover': {
                        borderColor: '#2099d2',
                        backgroundColor: '#2099d214',
                        color: '#2099d2',
                      },
                    }}
                  />
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    size="medium"
                    startIcon={<FileDownloadIcon />}
                    onClick={() => handleExportXlsx(selectedRows ?? [])}
                    sx={{
                      textTransform: 'none',
                      fontWeight: 600,
                      backgroundColor: '#2099d2',
                      '&:hover': { backgroundColor: '#176990' },
                    }}
                  >
                    Export
                  </Button>
                </Grid>
                <Grid item >
                  {user?.userRoles.split(",").includes("Super Admin") ? (
                    <MenuDropdown
                      menuTitle="Remove"
                      items={['Remove', 'Offset']}
                      onItemClick={item => {
                        if (item === 'Remove') {
                          handleDeleteItems();
                        } else if (item === 'Offset') {
                          handleOffsetItems();
                        }
                      }}
                      variant="outlined"
                      size="medium"
                      sx={{
                        textTransform: 'none',
                        fontWeight: 600,
                        borderColor: '#e2e8f0',
                        color: '#475569',
                        '&:hover': {
                          borderColor: '#2099d2',
                          backgroundColor: '#2099d214',
                          color: '#2099d2',
                        },
                      }}
                    />
                  ) : null}
                </Grid>
                <Grid item >
                  {user?.userRoles.split(",").includes("Super Admin") ? (
                    <Button
                      variant="contained"
                      size="medium"
                      startIcon={<CheckCircleIcon />}
                      onClick={() => onApproveItems(selectedRows ?? [])}
                      sx={{
                        textTransform: 'none',
                        fontWeight: 600,
                        backgroundColor: '#008000',
                        '&:hover': { backgroundColor: '#006400' },
                      }}
                    >
                      Approve
                    </Button>
                  ) : null}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <OffsetNotes open={open} handleClose={handleClose} setOffsetNotes={setOffsetNotes} handleUpdateOffsetNotes={handleUpdateOffsetNotes} />
      </React.Fragment>
    )
  }

  const initialdata: OTRFlags = {
    fieldName: "",
    errorMessage: "",
  }

  const getDetailPanelHeight = React.useCallback(() => 200, []);

  const columns: GridColDef[] = [
    {
      field: 'id',
      headerName: "Action",
      minWidth: 100,
      align: 'center',
      headerAlign: 'center',
      disableColumnMenu: true,
      filterable: false,
      sortable: false,
      renderCell: (params) => (<div>
        <IconButton
          color="primary"
          onClick={() => { handleEdit(params.row) }}
          sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(32,153,210,0.15) !important' } }}
        >
          <Tooltip
            title="Edit"
            placement="top"
            arrow
          >
            <EditOutlinedIcon fontSize="medium" color="primary" />
          </Tooltip>
        </IconButton >
      </div>)
    },
    {
      field: 'rowNum',
      type: 'number',
      headerName: 'No',
      hide: true,
      hideable: false,
      disableExport: true,
    },
    {
      field: "invoiceNumber",
      type: "string",
      headerName: "Invoice Number",
      minWidth: 175,
      headerAlign: "left",
      align: "left", hideSortIcons: true,
      filterOperators,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'invoiceNumber'
          );
      
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
        <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )},
      valueGetter: (params) => {
        return params.value
      },
    },
    {
      field: "insuredName",
      type: "string",
      headerName: "Insured Name",
      minWidth: 200,
      headerAlign: "left",
      align: "left", hideSortIcons: true,
      filterOperators,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'insuredName'
          );
      
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
        <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )},
      valueGetter: (params) => {
        return params.value
      },
    },
    {
      field: "policyNumber",
      type: "string",
      headerName: "Policy Number",
      minWidth: 170,
      headerAlign: "left",
      align: "left", hideSortIcons: true,
      filterOperators,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'policyNumber'
          );
      
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
        <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )},
      valueGetter: (params) => {
        return params.value
      },
    },
    {
      field: "homeState",
      type: "string",
      headerName: "State",
      minWidth: 100,
      headerAlign: "left",
      align: "left", hideSortIcons: true,
      filterOperators,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'homeState'
          );
      
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
        <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )},
      valueGetter: (params) => {
        return params.row?.homeState || params.row?.stateName || params.value;
      },
      renderCell: (params) => {
        return <div>{params.value}</div>
      },
    },
    {
      field: "taxType",
      type: "string",
      headerName: "Tax Type",
      minWidth: 150,
      headerAlign: "left",
      align: "left", hideSortIcons: true,
      filterOperators,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'taxType'
          );
      
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
        <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )},
      valueGetter: (params) => {
        return params.row?.taxType || params.row?.taxName || params.value;
      },
      renderCell: (params) => {
        return <div>{params.value}</div>
      },
    },
    {
      field: "taxPayee",
      type: "string",
      headerName: "Tax Payee",
      minWidth: 200,
      headerAlign: "left",
      align: "left", hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'taxPayee'
          );
      
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
        <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )},
      valueGetter: (params) => {
        return params.value
      },
    },
    {
      field: "transactionType",
      type: "string",
      headerName: "Transaction Type",
      minWidth: 200,
      headerAlign: "left",
      align: "left", hideSortIcons: true,
      filterOperators,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'transactionType'
          );
      
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
        <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )},
      valueGetter: (params) => {
        return params.row?.transactionType || params.row?.transactionTypeName || params.value;
      },
      renderCell: (params) => {
        const value = params.value;
        const isNumber = value !== null && value !== undefined && value !== '' && !isNaN(Number(value)) && isFinite(Number(value));
        const isValidTransactionType = value && !isNumber && transactionTypeList.some(
          tr => tr.possibleValues.some(pv => compactString(pv) === compactString(String(value))) || compactString(tr.value) === compactString(String(value))
        );
        const shouldShowError = value && (!isValidTransactionType || isNumber);
        
        // If invalid, show dropdown to select valid transaction type
        if (shouldShowError) {
          // Find current transactionTypeId if exists
          const currentTransactionTypeId = params.row?.transactionTypeId || 
            Transactions.find(t => t.transactionTypeName === value)?.transactionId || 0;
          
          return (
            <FormControl size="small" fullWidth>
              <Select
                value={currentTransactionTypeId}
                displayEmpty
                onChange={(e) => {
                  const selectedId = Number(e.target.value);
                  const selectedTransaction = Transactions.find(t => t.transactionId === selectedId);
                  
                  if (selectedTransaction) {
                    const rowData = params.row;
                    
                    // Build update payload similar to AddEditOTR.tsx
                    const updatedRow: OTRModuleModel = {
                      NewOpenTaxReportId: rowData.NewOpenTaxReportId || rowData.newOpenTaxReportId,
                      invoiceNumber: rowData.invoiceNumber,
                      insuredName: rowData.insuredName,
                      policyNumber: rowData.policyNumber,
                      homeState: rowData.homeState || rowData.stateName,
                      taxType: rowData.taxType || rowData.taxName,
                      taxPayee: rowData.taxPayee,
                      transactionType: selectedTransaction.transactionTypeName,
                      transactionTypeId: selectedTransaction.transactionId,
                      coverage: rowData.coverage,
                      carrier: rowData.carrier || rowData.carrierName,
                      naic: rowData.naic || rowData.naicNumber,
                      transEffDate: rowData.transEffDate,
                      invDate: rowData.invDate,
                      policyEffDate: rowData.policyEffDate,
                      policyExpDate: rowData.policyExpDate,
                      grossPremium: rowData.grossPremium,
                      nonAdmittedPremium: rowData.nonAdmittedPremium,
                      taxableFees: rowData.taxableFees,
                      nonTaxableFees: rowData.nonTaxableFees,
                      taxAmt: rowData.taxAmt,
                      taxBalance: rowData.taxBalance,
                      client: rowData.client || rowData.customerName,
                      clientDiv: rowData.clientDiv,
                      partnersId: rowData.partnersId || rowData.partnerId,
                      stateId: rowData.stateId,
                    };
                    
                    console.log('Updating transaction type:', updatedRow);
                    onItemChange(updatedRow);
                    // Refresh data after update
                    setTimeout(() => {
                      fetchData();
                    }, 500);
                  }
                }}
                sx={{
                  color: '#cc0000',
                  fontWeight: 'bold',
                  textAlign: 'left',
                  '.MuiSelect-select': { textAlign: 'left', paddingLeft: '8px' },
                  '.MuiOutlinedInput-notchedOutline': { border: 'none' },
                  '&:hover .MuiOutlinedInput-notchedOutline': { border: 'none' },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { border: 'none' },
                }}
                renderValue={() => (
                  <span style={{ color: '#cc0000' }}>{value || 'Select...'}</span>
                )}
              >
                <MenuItem value={0} disabled>
                  <em>Select Transaction Type</em>
                </MenuItem>
                {Transactions.filter(t => t.transactionId !== 0).map((transaction) => (
                  <MenuItem key={transaction.transactionId} value={transaction.transactionId}>
                    {transaction.transactionTypeName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          );
        }
        
        // Valid transaction type - show normal text
        return (
          <div
            style={{
              borderRadius: '4px',
              padding: '4px 8px',
              textAlign: 'left',
              width: '100%',
            }}
          >
            {value}
          </div>
        );
      },
    },
    {
      field: "coverage",
      type: "string",
      headerName: "Coverage",
      minWidth: 150,
      headerAlign: "left",
      align: "left", hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'coverage'
          );
      
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
        <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )},
      valueGetter: (params) => {
        return params.value
      },
    },
    {
      field: "carrierName",
      type: "string",
      headerName: "Carrier",
      minWidth: 250,
      headerAlign: "left",
      align: "left", hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'carrierName'
          );
      
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
        <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )},
      renderCell: (params) => {
        return <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{params.value}</div>
      },
    },
    {
      field: "naic",
      type: "string",
      headerName: "NAIC",
      minWidth: 80,
      headerAlign: "left",
      align: "left", hideSortIcons: true,
      filterOperators,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'transEffDate'
          );
      
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
        <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )},
      valueGetter: (params) => {
        return params.row?.naic || params.row?.naicNumber || params.value;
      },
    },
    {
      field: "transEffDate",
      type: "string",
      headerName: "Transaction Effective Date",
      minWidth: 245,
      headerAlign: "left",
      align: "left", hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'transEffDate'
          );
      
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
        <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )},
      valueGetter: (params) => {
        return !params.value ? '' : formatUtcToLocal(params.row?.transEffDate, "MM/DD/YYYY")
      },
    },
    {
      field: "invDate",
      type: "string",
      headerName: "Invoice Date",
      minWidth: 140,
      headerAlign: "left",
      align: "left", hideSortIcons: true,
      filterOperators,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'invDate'
          );
      
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
        <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )},
      valueGetter: (params) => {
        return !params.value ? '' : formatUtcToLocal(params.row?.invDate, "MM/DD/YYYY")
      },
    },
    {
      field: "policyEffDate",
      type: "string",
      headerName: "Policy Effective Date",
      minWidth: 200,
      headerAlign: "left",
      align: "left", hideSortIcons: true,
      filterOperators,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'policyEffDate'
          );
      
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
        <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )},
      valueGetter: (params) => {
        return !params.value ? '' : formatUtcToLocal(params.row?.policyEffDate, "MM/DD/YYYY")
      },
    },
    {
      field: "policyExpDate",
      type: "string",
      headerName: "Policy Expire Date",
      minWidth: 190,
      headerAlign: "left",
      align: "left", hideSortIcons: true,
      filterOperators,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'policyExpDate'
          );
      
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
        <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )},
      valueGetter: (params) => {
        return !params.value ? '' : formatUtcToLocal(params.row?.policyExpDate, "MM/DD/YYYY")
      },
    },
    {
      field: "grossPremium",
      type: "string",
      headerName: "Gross Premium",
      minWidth: 170,
      headerAlign: "right",
      align: "right",
      hideSortIcons: true,
      filterOperators,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'grossPremium'
          );
      
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
        <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )},
      valueGetter: (params) => {
        return formatPrice(params.value);
      },
    },

    {
      field: "nonAdmittedPremium",
      type: "string",
      headerName: "Non Admitted Premium",
      minWidth: 240,
      headerAlign: "right",
      align: "right", hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'nonAdmittedPremium'
          );
      
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
        <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )},
      valueGetter: (params) => {
        return formatPrice(params.value)
      },
    },
    {
      field: "taxableFees",
      type: "string",
      headerName: "Taxable Fees",
      minWidth: 170,
      headerAlign: "right",
      align: "right", hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'taxableFees'
          );
      
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
        <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )},
      valueGetter: (params) => {
        return formatPrice(params.value)
      },
    },
    {
      field: "nonTaxableFees",
      type: "string",
      headerName: "Non Taxable Fees",
      minWidth: 200,
      headerAlign: "right",
      align: "right", hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'nonTaxableFees'
          );
      
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
        <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )},
      valueGetter: (params) => {
        return formatPrice(params.value)
      },
    },
    {
      field: "taxAmt",
      type: "string",
      headerName: "Tax Amount",
      minWidth: 165,
      headerAlign: "right",
      align: "right", hideSortIcons: true,
      filterOperators,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'taxAmt'
          );
      
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
        <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )},
      valueGetter: (params) => {
        return formatPrice(params.value)
      },
    },
    {
      field: "taxBalance",
      type: "string",
      headerName: "Tax Balance",
      minWidth: 165,
      headerAlign: "right",
      align: "right", hideSortIcons: true,
      filterOperators,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'taxBalance'
          );
      
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
        <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )},
      valueGetter: (params) => {
        return formatPrice(params.value)
      },
    },
    {
      field: "client",
      type: "string",
      headerName: "Client",
      minWidth: 200,
      headerAlign: "left",
      align: "left", hideSortIcons: true,
      filterOperators,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'client'
          );
      
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
        <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )},
      valueGetter: (params) => {
        return params.row?.client || params.row?.customerName || params.value;
      },
      renderCell: (params) => {
        return <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{params.value}</div>
      },
    },
    {
      field: "clientDiv",
      type: "string",
      headerName: "ClientDiv",
      minWidth: 130,
      headerAlign: "left",
      align: "left", hideSortIcons: true,
      filterOperators,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'clientDiv'
          );
      
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
        <div>
            <span className="table-card-title" >{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )},
      valueGetter: (params) => {
        return params.value
      },
    },
  ]

  return (
    <div style={{ flex: 1, minHeight: 0, width: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
          borderRadius: '12px',
          overflow: 'hidden',
          boxShadow: '0 4px 24px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(15, 23, 42, 0.06)',
          border: '1px solid #e2e8f0',
          backgroundColor: '#ffffff',
        }}
      >
        <DataGridPro
          apiRef={otrGridApiRef}
          sortModel={sortModel}
          onSortModelChange={(newSortModel: any) => {
            setSortModel(newSortModel);
            if (onSortChange && newSortModel?.length > 0) {
              const { field, sort } = newSortModel[0];
              onSortChange(field, sort === 'desc' ? 'desc' : 'asc');
            }
          }}
          getRowId={(r) => r.rowNum}
          rows={listData}
          columns={columns.filter(column => !column.hide)}
          pageSize={pageSize}
          page={currentPage}
          pagination
          paginationMode="server"
          rowCount={totalCount}
          rowsPerPageOptions={[25, 50, 100]}
          sortingMode="server"
          filterMode="server"
          filterModel={filterModel}
          onFilterModelChange={(newFilterModel: any) => {
            if (onFilterChange) {
              onFilterChange(newFilterModel);
            }
          }}
          checkboxSelection={
            user?.userRoles.split(",").includes("Super Admin") ? true : false
          }
          onPageChange={(newPage) => onPageChange(newPage)}
          onPageSizeChange={(newPageSize) => onPageSizeChange(newPageSize)}
          onSelectionModelChange={
            user?.userRoles.split(",").includes("Super Admin")
              ? (newRowSelectionModel) => {
                onRowsSelectionHandler(newRowSelectionModel)
              }
              : undefined
          }
          selectionModel={selectionModel}
          disableSelectionOnClick
          sx={{
            fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            border: 'none',
            fontSize: '14px',
            color: '#475569',
            backgroundColor: '#ffffff',
            '& .MuiDataGridPro-columnHeaderTitle': {
              whiteSpace: 'normal',
              lineHeight: 1.35,
              fontWeight: 600,
              fontSize: '12px',
              letterSpacing: '0.05em',
              textTransform: 'uppercase',
              color: '#64748b',
            },
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#f8fafc',
              borderBottom: '2px solid #e2e8f0',
              borderTop: '2px solid #e2e8f0',
              minHeight: '52px !important',
              maxHeight: '52px !important',
            },
            '& .MuiDataGrid-columnHeader': {
              '&:focus, &:focus-within': { outline: 'none' },
            },
            '& .MuiDataGrid-row': {
              transition: 'background-color 0.15s ease',
              '&:nth-of-type(even)': {
                backgroundColor: '#fafbfc',
              },
              '&:hover': {
                backgroundColor: '#f1f5f9 !important',
              },
              '&.Mui-selected': {
                backgroundColor: '#ebf5fa !important',
                '&:hover': {
                  backgroundColor: '#dbeef7 !important',
                },
              },
            },
            '& .MuiDataGrid-cell': {
              borderBottom: '1px solid #f1f5f9',
              fontSize: '14px',
              color: '#334155',
              overflow: 'visible',
              whiteSpace: 'normal',
              lineHeight: 'normal',
              wordWrap: 'break-word',
              textOverflow: 'clip',
              padding: '8px 16px',
              '&:focus': { outline: 'none' },
            },
            '.MuiDataGrid-cellContent': {
              textAlign: 'center',
              WebkitLineClamp: 2,
              lineClamp: 2,
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              textOverflow: 'ellipsis',
            },
            '& .MuiDataGrid-virtualScroller': {
              marginTop: '50px !important',
              border: 'none',
            },
            '& .MuiDataGrid-main': {
              border: 'none',
            },
            '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
              marginBottom: '0px !important',
            },
            '& .MuiDataGrid-footerContainer': {
              borderTop: '1px solid #e2e8f0',
              backgroundColor: '#f8fafc',
              minHeight: 56,
            },
            '& .MuiTablePagination-root': {
              color: '#64748b',
              fontSize: '13px',
            },
            '& .MuiTablePagination-select': {
              fontSize: '13px',
              borderRadius: '6px',
              border: '1px solid #e2e8f0',
            },
            '& .MuiIconButton-root': {
              color: '#64748b',
              '&:hover': {
                backgroundColor: '#f1f5f9',
                color: '#475569',
              },
            },
            '& .MuiCheckbox-root': {
              color: '#94a3b8',
              '&.Mui-checked': {
                color: '#2099d2',
              },
            },
            '.custom-cell': {
              button: {
                padding: 0,
                width: '100%',
                height: '100%',
                textAlign: 'center',
                WebkitLineClamp: 2,
                lineClamp: 2,
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                textOverflow: 'ellipsis',
              },
            },
          }}
          components={{
            Toolbar: EditToolbar,
          }}
          experimentalFeatures={{ newEditingApi: true }}
        />
      </Box>
      <AddEditOTR
        handleClose={handleCloseOTREdit}
        Open={OpenOTREdit}
        opentaxreportCL={Formdata}
        handleSubmit={handleSubmit}
        initValues={initialOTRModelDTO}
        states={States}
        Transactions={Transactions}
      />
    </div>
  )
}
